import moment from 'moment';
import get from 'lodash-es/get';

import {
  getTravelCheckoutFormValues,
  getTravelQuotation,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  ModelPathEnum,
} from 'app/shared/enums';
import { getBirthdayStringByPesel } from 'app/services/pesel.service';
import { TravelQuotationService } from 'app/services/travelQuotation.service';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';
import { validateTravelPeselUniqueness } from 'app/services/businessFunctions/helpers/validateTravelPeselUniqueness';

const formName = FormsEnum.TravelCheckoutForm;

const insurantDetails = {
  travelCheckoutInsurantPeselChange() {
    const pesel = get(
      getTravelCheckoutFormValues(),
      FieldsEnum.TravelInsurantPesel
    );
    const quotation = getTravelQuotation();
    const birthDate = getBirthdayStringByPesel(pesel);
    const age = moment().diff(birthDate, 'years');
    const isAdult = age >= 18;
    const isValid = birthDate !== undefined;
    const isUnique = validateTravelPeselUniqueness(
      FieldsEnum.TravelInsurantPesel
    );
    const isPeselCorrect = isValid && isAdult && isUnique;

    setMessageVisibility({
      key: MessagesEnum.CheckoutInsurantToYoung,
      visible: isValid && !isAdult,
      formName,
    });

    setMessageVisibility({
      key: getMessageKeyWithSuffix(
        FieldsEnum.TravelInsurantPesel,
        'notUnique_pesel_short'
      ),
      visible: isValid && !isUnique,
      formName,
    });

    setMessageVisibility({
      formName: FormsEnum.TravelCheckoutForm,
      key: getMessageKeyWithSuffix(
        FieldsEnum.TravelCheckoutInsurantPesel,
        'too_young_owner_pesel'
      ),
      visible: false,
    });

    if (!isPeselCorrect && pesel !== '') {
      return;
    }

    TravelQuotationService.update(
      quotation.id,
      ModelPathEnum.TravelInsurantPesel,
      pesel
    );
  },
};

export default insurantDetails;
